import {
    notification,
    // Button 
} from 'antd';
// import React from 'react'

const NotificationType = {
    INFO: "info",
    SUCCESS: "success",
    WARNING: "warning",
    ERROR: "error"
};

export function useNotification() {

    function createNotification(type, message, description, error) {

        // const key = `open${Date.now()}`;
        // const btn = (
        //     <Button type="primary" size="small" onClick={() => notification.close(key)}>
        //     Confirm
        //     </Button>
        // );
        // function close(){ 
        // }

        let duration = 3.5; //default
        if (type === NotificationType.ERROR) {
            duration = 0; //infinite
        }

        const args = {
            message: message,
            description: description,
            duration: duration,
            type: type,
            placement: "bottomLeft",
            // key,
            // btn,
            // onClose: close
        };

        notification.open(args)
    }

    return [createNotification, NotificationType]
}

